import { Control, FilterType } from '../../types/types';

export const resolveFilterMatchModeType = (
  type: FilterType | undefined,
  control: Control | undefined
): string | undefined => {
  if (
    control?.type === 'radioBtn' ||
    control?.type === 'combobox' ||
    control?.type === 'checkbox' ||
    control?.type === 'multiCheckbox'
  ) {
    return control?.type;
  }

  if (control?.type === 'reference') {
    return control.multiSelect
      ? 'referenceMultiSelect'
      : 'referenceSingleSelect';
  }

  return type;
};
